import React from 'react'
import PropTypes from 'prop-types'

// Components
import Layout from '../components/layout'

// Libs
import MarkDown from 'react-markdown'

// Gatsby
import { graphql } from 'gatsby'
import Img from 'gatsby-image'

export const query = graphql`
query EquipmentsQuery {
  allStrapiEquipos {
    nodes {
      strapiId
      name
      description
      image {
        childImageSharp {
          fixed(width: 300 height: 250) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  }
}
`

const EquipmentsPage = ({ data }) => {
  const { allStrapiEquipos: { nodes: equipments } } = data
  console.log({ equipments })
  return (
    <Layout>
      <section className="pt-64 bg-gray-200">
        <div className="grid grid-cols-12">
          <div className="col-start-2 col-span-10">
            <h1 className="mt-32 lg:mt-0 text-4xl md:text-6xl text-center">Equipos médicos</h1>
            <div className="grid grid-cols-12 gap-2">
              {equipments && equipments.length > 0 &&
                equipments.map((e, i) => (
                  <div className="lg:col-span-4 col-span-12 p-2 border w-full text-center hover:shadow-lg bg-white" style={{ minHeight: 500 }} key={i}>
                    <Img fixed={e.image.childImageSharp.fixed} />
                    <h2 data-aos='zoom-in' data-aos-duration="800">{e.name}</h2>
                    <div data-aos='zoom-in' data-aos-duration="800" className="p-8">
                      <MarkDown className="text-justify" source={e.description} />
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

EquipmentsPage.propTypes = {
  data: PropTypes.object
}

export default EquipmentsPage